export default {"src":"/_next/static/media/404-light.0fe7e406.svg","height":600,"width":900,"blurWidth":0,"blurHeight":0};